export const TOKEN_STORAGE = 'saywhattToken';
export const CHAT_ID_STORAGE = 'saywhattChatId';
export const OPEN_CHAT_STORAGE = 'saywhattIsOpenChat';
export const SESSION_FINISH_TIME_STORAGE = 'saywhattSessionFinishTime';
export const VIEWED_PRODUCTS_STORAGE = 'saywhattViewedProducts';
export const WIDGET_POPUPS_STATE_STORAGE = 'saywhattWidgetPopupsState';
